import ReactDOM from 'react-dom';
import { Spinner } from '../../spinner/spinner';
import { bodyAppendDivElement } from '../../utils';
import './style.less';

const closeDialogPageSpinner = () => {
  try {
    const element = document.querySelector('.v-dialog-page-spinner');
    if (element) {
      const elementParent = document.querySelector('.v-dialog-page-spinner')?.parentNode;
      document.body.removeChild(elementParent as Node);
    }
    const globalSpinnerElement = document.querySelector('#global-spinner') as Element;
    if (globalSpinnerElement) {
      const classList = globalSpinnerElement.classList;
      classList.remove('show');
      classList.add('hide');
    }
  } catch (error) {
    // 异常不处理
    console.warn('closeDialogPageSpinner error', error);
  }
};

export const dialogPageSpinner = {
  show: () => {
    const spinnerInst = document.querySelector('.v-dialog-page-spinner');
    if (spinnerInst) {
      return;
    }
    const { divElement } = bodyAppendDivElement();
    ReactDOM.render(
      <Spinner spinning={true} className="v-dialog-page-spinner" style={{ zIndex: 999 }} />,
      divElement,
    );
  },
  hide: closeDialogPageSpinner,
};
